import React, { useEffect, useState } from "react";
import {
  Flex,
  Stack,
  Spacer,
  HStack,
  VStack,
  Box,
  Text,
  Button,
  Heading,
} from "@chakra-ui/react";
import HomeTitle from "./HomeTitle";
import MainLink from "../MainLink";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowDown,
} from "react-icons/md";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import Head from "next/head";

const Qa = ({ q, children }) => {
  return (
    <>
      <Box
        background="#F1F1F1"
        border="1px solid rgba(0, 0, 0, 0.2)"
        borderRadius="11px"
        py="6px"
        px="15px"
        mt="15px"
      >
        <Heading as="h3" fontSize="22px" fontWeight="400" lineHeight={1.5}>
          {q}
        </Heading>
      </Box>
      <Text
        m={{ base: "14px 8px 19px 8px", md: "18px 57px 28px 57px" }}
        fontSize="15px"
        lineHeight="30px"
        color="#313131"
      >
        {children}
      </Text>
    </>
  );
};

const QAs = ({ isOpen, open }) => {
  const router = useRouter();
  const { locale } = router;
  const isTw = locale === "zh-TW";
  const { t } = useTranslation("common");

  return isOpen ? (
    <Box>
      <Flex direction="column" maxW="721px" w="100%">
        <Qa q={t(`HomeFAQ.q1_q`)}>
          {t(`HomeFAQ.q1_a`)}
          <br />
          <MainLink href="https://www.udrive.city/blog/3134">
            {t(`HomeFAQ.q1_link`)}
          </MainLink>
        </Qa>

        {[2, 3, 4, 5].map((item) => (
          <Qa key={item} q={t(`HomeFAQ.q${item}_q`)}>
            {t(`HomeFAQ.q${item}_a`)}
          </Qa>
        ))}
      </Flex>
    </Box>
  ) : (
    <Button
      onClick={() => open(true)}
      border="1px solid #333"
      bgColor="#fff"
      lineHeight="1"
    >
      {t("faqOpenButton")}
    </Button>
  );
};

const HomeFAQ = () => {
  const router = useRouter();
  const { t } = useTranslation("common");
  useEffect(() => {
    if (router.asPath.includes("#faq")) {
      open(true);
    }
  }, [router.asPath]);
  const [isOpen, open] = useState(false);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [1, 2, 3, 4, 5].map((item) => ({
      "@type": "Question",
      name: t(`HomeFAQ.q${item}_q`),
      acceptedAnswer: {
        "@type": "Answer",
        text: t(`HomeFAQ.q${item}_a`),
      },
    })),
  };

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />
      </Head>
      <VStack
        as="section"
        id="faq"
        px="25px"
        py="50px"
        mt="-30px"
        pt="80px"
        cursor="pointer"
      >
        <HomeTitle
          onClick={() => open(!isOpen)}
          cursor="pointer"
          aria-expanded={isOpen}
          aria-controls="faq-content"
        >
          <HStack mb="20px">
            <Heading as="h2" size="lg" fontWeight="500">
              {t("faqTitle")}
            </Heading>
            {isOpen ? (
              <MdOutlineKeyboardArrowDown />
            ) : (
              <MdOutlineKeyboardArrowLeft />
            )}
          </HStack>
        </HomeTitle>
        <QAs id="faq-content" isOpen={isOpen} open={open} />
      </VStack>
    </>
  );
};

export default HomeFAQ;
